import { TOOL_COLLECTION_SELECTED } from "../actions";

const initialState = {
  activeTool: "Style",
  isVisible: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOOL_COLLECTION_SELECTED:
      // If clicking the same tool, just toggle visibility
      if (state.activeTool === action.payload.activeTool) {
        return {
          ...state,
          isVisible: action.payload.isVisible
        };
      }

      // For different tool, use payload values
      return {
        activeTool: action.payload.activeTool,
        isVisible: action.payload.isVisible
      };
    default:
      return state;
  }
}
